import React from 'react';


const Div = (props) => {
    const hidden = props.hidden;
    if (hidden) {
        return (<div style={{hidden: true}}/>);
    }

    return (
        <div>
            {props.children}
        </div>
    )
};

export default Div;
